// ** React Imports
import React, { Fragment, useEffect, useRef, useState } from 'react'
// import { useParams } from 'react-router-dom' // No longer needed for dispatch

// ** MUI Imports
import { styled } from '@mui/material/styles'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PickersRange from './SelectDateRangePicker'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'

// ** Icons Imports
import ArrowDown from 'mdi-material-ui/MenuDown'

// ** Third Party Libraries
import moment from 'moment'
// ** Redux Imports - No longer needed for this component's logic
// import { useDispatch } from 'react-redux'
// import { getCustomerInvoice } from 'store/customers'

// Styled Card component
const Item = styled(Typography)(({ theme }) => ({
  paddingTop: 5,
  paddingBottom: 5,
  paddingRight: 20,
  paddingLeft: 20,
  fontSize: '0.925rem',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#eee'
  }
}))

const SelectFilter = props => {
  // ** Hooks
  // const { id } = useParams() // No longer needed
  // const dispatch = useDispatch() // No longer needed

  // ** Props
  const { values, defaultValue, disabled, onDateChange } = props // Get onDateChange from props

  // ** Refs
  const wrapperRef = useRef(null)

  // ** State
  const [value, setValue] = useState(defaultValue)
  const [showList, setShowList] = useState(false)
  const [openDatePicker, setOpenDatePicker] = useState(false)

  // ** Hook which detect clicking outside the popper box
  useEffect(() => {
    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpenDatePicker(false)
        setShowList(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [wrapperRef])

  // This function now calculates dates and passes them up to the parent
  const onClickHandler = value => {
    setShowList(false)
    setValue(value) // Update local state to show the selected value

    let startDate = null
    let endDate = null

    if (value === 'Custom date range') {
      setOpenDatePicker(true)
      return // Exit early, date will be set by PickersRange
    } else if (value === 'This month') {
      startDate = moment().startOf('month').format('YYYY-MM-DD')
      endDate = moment().endOf('month').format('YYYY-MM-DD')
    } else if (value === 'Previous month') {
      startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
      endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
    } else if (value === 'Last 3 months') {
      startDate = moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD')
      endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
    } else if (value === 'This year') {
      startDate = moment().startOf('year').format('YYYY-MM-DD')
      endDate = moment().endOf('year').format('YYYY-MM-DD')
    } else if (value === 'Previous year') {
      startDate = moment().subtract(1, 'years').startOf('year').format('YYYY-MM-DD')
      endDate = moment().subtract(1, 'years').endOf('year').format('YYYY-MM-DD')
    } else if (value === 'All time') {
      // No date filter applied, pass null to show all
      startDate = null
      endDate = null
    }

    // Call the parent handler function with the new dates
    if (onDateChange) {
      onDateChange(startDate, endDate)
    }
  }

  // Handle custom date range selection from the date picker component
  const handleCustomDateApply = (startDate, endDate) => {
    setOpenDatePicker(false) // Close the date picker modal
    setValue('Custom date range') // Update the text field value

    // Pass the dates up to the main TransactionsList component
    if (onDateChange) {
      onDateChange(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'))
    }
  }

  return (
    <Fragment>
      <FormControl sx={{ mx: 4, color: '#444', minWidth: 150, position: 'relative' }} variant='standard'>
        <TextField
          variant='standard'
          size='small'
          value={value}
          sx={{ input: { cursor: 'default' } }}
          onClick={() => setShowList(true)}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position='end'>
                <ArrowDown sx={{ color: 'text.secondary' }} />
              </InputAdornment>
            ),
            style: {
              fontSize: '0.925rem'
            }
          }}
        />
      </FormControl>
      {showList && defaultValue === 'Last 3 months' && (
        <Box
          ref={wrapperRef}
          sx={{
            zIndex: theme => theme.zIndex.appBar - 5,
            backgroundColor: 'common.white',
            boxShadow: theme => theme.shadows[2],
            border: theme => `1px solid ${theme.palette.grey[400]}`,
            position: 'absolute',
            width: 176,
            height: 'fit-content',
            py: 3,
            ml: '2rem'
          }}
        >
          {values.map((el, index) => (
            <Item key={index} onClick={() => onClickHandler(el)}>
              {el}
            </Item>
          ))}
        </Box>
      )}
      {openDatePicker && (
        <Box
          ref={wrapperRef}
          sx={{
            zIndex: theme => theme.zIndex.appBar - 5,
            p: 5,
            mt: '8rem',
            backgroundColor: 'white',
            boxShadow: theme => theme.shadows[2],
            border: theme => `1px solid ${theme.palette.grey[400]}`,
            position: 'absolute',
            width: 300,
            height: 160
          }}
        >
          {/* Assuming PickersRange has an `onApply` prop to return selected dates */}
          <PickersRange setOpenDatePicker={setOpenDatePicker} onApply={handleCustomDateApply} />
        </Box>
      )}
    </Fragment>
  )
}

export default SelectFilter
